/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Knowledge_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "The agent reads a space with the rights of the person running it, so it never shows someone documents they could not open themselves." |
*
* @param {Uno_Edu_Agent_Knowledge_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_knowledge_chip2_answer = /** @type {((inputs?: Uno_Edu_Agent_Knowledge_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Knowledge_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agent liest einen Bereich mit den Rechten der Person, die ihn ausführt. Er zeigt also niemandem Dokumente, die diese Person nicht selbst öffnen könnte.")
	return /** @type {LocalizedString} */ ("The agent reads a space with the rights of the person running it, so it never shows someone documents they could not open themselves.")
});